import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import ComponentWithRedirectValidatableProperties from '../_componentWithRedirect/componentWithRedirectValidatableProperties.mdx';
import KlarnaValidatableProperties from '../_klarna/klarnaManagerValidatableProperties.mdx';
import AchValidatableProperties from '../_ach/achManagerValidatableProperties.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Item title='onInvalid' subtitle={`(data: PrimerInvalidComponentData<${props.parameterType}>) => void`} mdxType="Item">
Called to indicate that the component data was considered invalid during validation.
      <Group summary='Parameters' mdxType="Group">
        <Item title={`PrimerInvalidComponentData<${props.parameterType}>`} mdxType="Item">
          <p>{`Interface that indicates that the data has been considered invalid after validation.`}</p>
          <Group summary='Properties' mdxType="Group">
            <Item title='data' subtitle={props.parameterType} mdxType="Item">
    The data that failed validation.
    {props.properties === 'adyen-ideal' && <ComponentWithRedirectValidatableProperties mdxType="ComponentWithRedirectValidatableProperties" />}
    {props.properties === 'klarna' && <KlarnaValidatableProperties mdxType="KlarnaValidatableProperties" />}
    {props.properties === 'ach' && <AchValidatableProperties mdxType="AchValidatableProperties" />}
            </Item>
            <Item title='errors' subtitle="PrimerValidationError[]" mdxType="Item">
              <p>{`A list of `}<inlineCode parentName="p">{`PrimerValidationError`}</inlineCode>{` explaining why the data is considered invalid.`}</p>
              <Item title='PrimerValidationError[]' mdxType="Item">
    <Group mdxType="Group">
        <Item title='PrimerValidationError' mdxType="Item">
            <Group summary='Properties' mdxType="Group">
                <Item title='errorId' subtitle='string' mdxType="Item">
                    A unique error identifier.
                </Item>
                <Item title='description' subtitle='string' mdxType="Item">
                    A error description.
                </Item>
                <Item title='diagnosticsId' subtitle='string' w mdxType="Item">
                    A unique diagnostics id for the given error.
                </Item>
            </Group>
        </Item>
    </Group>
              </Item>
            </Item>
          </Group>
        </Item>
      </Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      